export const MAP_DATA = {
  type: 'FeatureCollection',
  name: 'A Block CGSA',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:EPSG::4269' } },
  features: [
    {
      type: 'Feature',
      properties: {
        ULS_ID: '1303123',
        DATE_GRANT: '2002-06-11',
        FILE_NUM: '0000917112',
        CALL_SIGN: 'KNKA805',
        MARKET: 'CMA256',
        BLOCK: 'A',
        DATE_CREAT: '2011-11-14',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.4452738278045, 37.75141384030627],
              [-78.496307, 37.794304],
              [-78.50415, 37.759636],
              [-78.612289, 37.756096000000184],
              [-78.66964, 37.724861],
              [-78.685745, 37.73625600000014],
              [-78.684105, 37.75924700000013],
              [-78.67185999999987, 37.75675200000012],
              [-78.839462, 38.047428],
              [-78.77744299999989, 38.092381000000216],
              [-78.787804, 38.117157],
              [-78.742584, 38.217384],
              [-78.682121, 38.254768],
              [-78.670067, 38.24713500000013],
              [-78.652153, 38.293514],
              [-78.551758, 38.336189],
              [-78.48365624682475, 38.42683972749563],
              [-78.43910599994183, 38.43322899971861],
              [-78.428543, 38.37323800000013],
              [-78.364449, 38.316032],
              [-78.365707, 38.29253800000015],
              [-78.331566, 38.271015],
              [-78.287132, 38.271507],
              [-78.370064, 38.184624000000156],
              [-78.21248325443167, 38.1343291002608],
              [-78.306877, 38.00626],
              [-78.06786899975452, 37.89895400022692],
              [-78.15963, 37.74818800000014],
              [-78.22823373728937, 37.70030041578423],
              [-78.30611660859921, 37.709748934710774],
              [-78.38028632756959, 37.75498795507434],
              [-78.42355468553956, 37.74081902849599],
              [-78.4452738278045, 37.75141384030627],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '19631',
        DATE_GRANT: '1997-12-05',
        FILE_NUM: '00830CLML98',
        CALL_SIGN: 'KNKN675',
        MARKET: 'CMA687',
        BLOCK: 'A',
        DATE_CREAT: '2011-11-14',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.6522897887952, 37.717544058548754],
              [-78.612289, 37.756096000000184],
              [-78.511238, 37.75745000000012],
              [-78.491837, 37.796574],
              [-78.467339, 37.762409000000105],
              [-78.424301, 37.740963],
              [-78.26577, 37.693649],
              [-78.240044, 37.690285],
              [-78.17223867441561, 37.74716761739609],
              [-78.15273842384796, 37.723386803018194],
              [-78.09997251413297, 37.58472675411893],
              [-78.132294, 37.454662],
              [-78.185318, 37.444267],
              [-78.24088299999988, 37.376698],
              [-78.23903900091, 37.15736532219756],
              [-78.32778143935157, 37.103987761824094],
              [-78.443588, 37.07917],
              [-78.4933089999999, 36.891075000000114],
              [-78.51292525797157, 36.86660501335109],
              [-78.56507085470885, 36.87282344115166],
              [-78.61204361225973, 36.85445586978199],
              [-78.5969951543371, 36.76885310317818],
              [-78.648819, 36.697773],
              [-78.6072134938264, 36.663347696953224],
              [-78.650078, 36.690128],
              [-78.702995, 36.675827],
              [-78.732147, 36.54747],
              [-79.15145787436933, 36.541582733660334],
              [-79.20479179237448, 36.596592948033745],
              [-79.11424232623557, 36.97202973404586],
              [-78.98503151002349, 37.01465080313895],
              [-78.97872811777536, 37.0437547019085],
              [-78.910667, 37.025665000000174],
              [-78.824478, 37.205215],
              [-78.68185399999987, 37.248596],
              [-78.595085, 37.34455100000014],
              [-78.594711, 37.39783500000016],
              [-78.631355, 37.3844380000001],
              [-78.634521, 37.412079],
              [-78.683853, 37.42905],
              [-78.76848327375785, 37.542889683663134],
              [-78.719307, 37.660999],
              [-78.689301, 37.676800000000185],
              [-78.695999, 37.692101],
              [-78.643402, 37.6819],
              [-78.6522897887952, 37.717544058548754],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '1415999',
        DATE_GRANT: '2002-09-13',
        FILE_NUM: '0001023262',
        CALL_SIGN: 'KNKA812',
        MARKET: 'CMA203',
        BLOCK: 'A',
        DATE_CREAT: '2011-11-14',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.07208965913338, 37.76068728920717],
              [-79.057663, 37.712143],
              [-78.986519, 37.697212],
              [-78.898872, 37.543926],
              [-78.8312, 37.5355],
              [-78.82549299999982, 37.552399],
              [-78.683853, 37.42905],
              [-78.636185, 37.416107000000125],
              [-78.631355, 37.3844380000001],
              [-78.595634, 37.399208],
              [-78.601791, 37.337616],
              [-78.68185399999987, 37.248596],
              [-78.824478, 37.205215],
              [-78.904854, 37.02214800000013],
              [-78.967926, 37.045536],
              [-79.006157, 37.029861],
              [-79.057098, 37.04529200000019],
              [-79.127403, 37.089725],
              [-79.188179, 37.056995],
              [-79.21328699999987, 37.11776],
              [-79.232086, 37.098736],
              [-79.25428, 37.132751],
              [-79.283173, 37.10554900000017],
              [-79.337578, 37.136173],
              [-79.376785, 37.12085000000013],
              [-79.37043, 37.10860800000012],
              [-79.404984, 37.09163700000016],
              [-79.404854, 37.06354900000014],
              [-79.443138, 37.05572100000012],
              [-79.232254, 37.39481400000011],
              [-79.256882, 37.406433000000106],
              [-79.244797, 37.41980000000012],
              [-79.268974, 37.43088900000015],
              [-79.2677, 37.447300000000155],
              [-79.185905, 37.4659],
              [-79.2407, 37.50605800000011],
              [-79.25911699999989, 37.494015],
              [-79.261993, 37.507996],
              [-79.293373, 37.499264],
              [-79.34265099999988, 37.518345000000124],
              [-79.380699, 37.582146],
              [-79.32273000018927, 37.62598900019219],
              [-79.3922110000376, 37.60586200013131],
              [-79.435402, 37.603741],
              [-79.437286, 37.616882],
              [-79.345558, 37.660526],
              [-79.264641, 37.794533000000115],
              [-79.231415, 37.813072],
              [-79.209496, 37.78890200000012],
              [-79.180305, 37.795128],
              [-79.18829499971446, 37.75507400036486],
              [-79.089493, 37.787910000000124],
              [-79.07208965913338, 37.76068728920717],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '19651',
        DATE_GRANT: '1997-01-09',
        FILE_NUM: '01417CLML97',
        CALL_SIGN: 'KNKN747',
        MARKET: 'CMA685',
        BLOCK: 'A',
        DATE_CREAT: '2011-11-14',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.29341826773896, 37.97515796502165],
              [-79.184227, 37.914059],
              [-79.143639, 37.859253],
              [-79.180305, 37.795128],
              [-79.209496, 37.78890200000012],
              [-79.231415, 37.813072],
              [-79.246178, 37.805161],
              [-79.308784, 37.734081],
              [-79.345558, 37.660526],
              [-79.45771, 37.605930000000114],
              [-79.440926, 37.563393],
              [-79.496872, 37.5367930000001],
              [-79.68383, 37.66153700000012],
              [-79.667961, 37.69427100000013],
              [-79.68895, 37.734539],
              [-79.67424, 37.76292400000011],
              [-79.816925, 37.800861],
              [-79.917786, 37.701725000000124],
              [-80.020744, 37.64733100000012],
              [-80.032928, 37.660164],
              [-80.06671943110132, 37.64061733496948],
              [-80.1484303491514, 37.67094464825982],
              [-80.20515098133465, 37.723351240549995],
              [-80.22656050636675, 37.76863778504405],
              [-80.218826, 37.809662],
              [-80.123833, 37.89782],
              [-80.03202544796278, 37.914154669102125],
              [-79.94813221037182, 37.87182815489591],
              [-79.98111099957293, 37.95033199982197],
              [-79.98201800003068, 38.012100000115026],
              [-79.93562300000144, 38.05787100014652],
              [-79.8298280000621, 38.103702000247154],
              [-79.7464359999214, 38.115838999670075],
              [-79.61452900001325, 38.098735999666644],
              [-79.51100200034205, 38.048790999605046],
              [-79.47408100013797, 38.012100000115026],
              [-79.46838600011381, 37.984212000083744],
              [-79.34977399997013, 38.00210499964612],
              [-79.29341826773896, 37.97515796502165],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '6616005',
        DATE_GRANT: '2012-04-18',
        FILE_NUM: '0005069764',
        CALL_SIGN: 'KNKN714',
        MARKET: 'CMA686',
        BLOCK: 'A',
        DATE_CREAT: '2012-02-14',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.14459762973473, 38.63156900926526],
              [-79.12250499999988, 38.659698],
              [-79.093002, 38.659698],
              [-79.093201, 38.701599],
              [-79.055199, 38.785599],
              [-79.027504, 38.792],
              [-78.994247, 38.849991],
              [-78.642029, 38.60459900000012],
              [-78.691566, 38.50988400000011],
              [-78.636292, 38.497192],
              [-78.62316899999985, 38.465637000000186],
              [-78.558792, 38.44731900000011],
              [-78.54904199999987, 38.426395],
              [-78.48551166780881, 38.43953882006867],
              [-78.45539969739106, 38.5470605979433],
              [-78.413488000271, 38.5545800002667],
              [-78.420151, 38.534248],
              [-78.443161, 38.5276300000001],
              [-78.45128257800661, 38.47854456897079],
              [-78.437294, 38.43914],
              [-78.481918, 38.43047700000017],
              [-78.543015, 38.364895000000104],
              [-78.551758, 38.336189],
              [-78.652153, 38.293514],
              [-78.662552, 38.253307],
              [-78.726662, 38.23169700000017],
              [-78.772057, 38.165951],
              [-78.781334, 38.08062000000018],
              [-78.839462, 38.047428],
              [-78.69175, 37.796574],
              [-78.693619, 37.770916],
              [-78.667992, 37.759384000000125],
              [-78.685745, 37.73625600000014],
              [-78.658897, 37.72268300000013],
              [-78.644302, 37.733002],
              [-78.656197, 37.7034],
              [-78.643402, 37.6819],
              [-78.69010199999985, 37.69860100000011],
              [-78.719307, 37.660999],
              [-78.712997, 37.640499],
              [-78.75446397983706, 37.63450980030143],
              [-78.7665924189871, 37.607309237460264],
              [-78.828201, 37.59520000000015],
              [-78.813599, 37.56800100000015],
              [-78.823402, 37.539501],
              [-78.894157, 37.543377],
              [-78.986519, 37.697212],
              [-79.06739799999986, 37.719513],
              [-79.07144199999988, 37.778214],
              [-79.11457799999982, 37.786716],
              [-79.138252, 37.813972],
              [-79.16855212354756, 37.80907659853426],
              [-79.143639, 37.859253],
              [-79.184227, 37.914059],
              [-79.34652302180069, 38.00517018680961],
              [-79.45509607713649, 38.00771993303334],
              [-79.59913299958811, 38.09473799965912],
              [-79.58905499978829, 38.14566900022419],
              [-79.55406499960003, 38.19342900024816],
              [-79.70642099999986, 38.221069],
              [-79.796143, 38.26543],
              [-79.786697, 38.274529],
              [-79.808937, 38.3093070000001],
              [-79.764656, 38.35639600000019],
              [-79.73228499999988, 38.360046],
              [-79.72042786951187, 38.39663869169243],
              [-79.80347199963308, 38.45966200010122],
              [-79.82309799997262, 38.556285999799115],
              [-79.776506999976, 38.62146299999051],
              [-79.71505799996424, 38.669564000316484],
              [-79.68460200016943, 38.68548900004214],
              [-79.60996296944171, 38.6776565915844],
              [-79.5942, 38.665699],
              [-79.63402100346097, 38.591632271212234],
              [-79.62540699691039, 38.582620053710855],
              [-79.537102, 38.5508],
              [-79.476875, 38.457108],
              [-79.312515, 38.411751],
              [-79.242882, 38.454044],
              [-79.176506, 38.5658],
              [-79.16347358839789, 38.48318929542353],
              [-79.11407299976895, 38.564199999630375],
              [-79.14518600013372, 38.60516600021083],
              [-79.14459762973473, 38.63156900926526],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '3795784',
        DATE_GRANT: '2007-01-12',
        FILE_NUM: '0002876402',
        CALL_SIGN: 'KNKN670',
        MARKET: 'CMA683',
        BLOCK: 'A',
        DATE_CREAT: '2012-03-28',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-80.97855315187735, 37.29225271351237],
              [-80.919456, 37.306046],
              [-80.84964799999989, 37.34678600000018],
              [-80.883446, 37.383812],
              [-80.859749, 37.429447],
              [-80.784393, 37.394466],
              [-80.770287, 37.37224600000013],
              [-80.51535, 37.478443],
              [-80.493202, 37.457623],
              [-80.4950869999999, 37.434944000000144],
              [-80.475822, 37.42282500000016],
              [-80.430977, 37.31605500000012],
              [-80.328125, 37.366665],
              [-80.262215, 37.340565],
              [-80.258751, 37.308216],
              [-80.191246, 37.232487],
              [-80.17826799999989, 37.11330000000021],
              [-80.12335999999988, 37.11957200000012],
              [-80.107903, 37.07313500000015],
              [-80.11972, 37.049374],
              [-80.104652, 37.026314],
              [-80.13610099999983, 37.003948],
              [-80.125641, 36.99615100000011],
              [-80.134689, 36.964951],
              [-80.17543, 36.951206000000184],
              [-80.199104, 36.90137900000019],
              [-80.235687, 36.87199800000013],
              [-80.073898, 36.8461690000002],
              [-80.072281, 36.82195300000012],
              [-80.04348, 36.800365],
              [-80.095375, 36.778069],
              [-80.094185, 36.725063],
              [-80.050446, 36.609196],
              [-80.05369599999989, 36.54234700000012],
              [-80.838158, 36.55901300000011],
              [-80.914375, 36.650120000000186],
              [-80.8774719999999, 36.692089000000124],
              [-80.91782399999988, 36.694038],
              [-80.932365, 36.671341],
              [-81.04260299999987, 36.80630100000019],
              [-80.740685, 36.878876000000105],
              [-80.893448, 37.027279000000135],
              [-80.930824, 37.114967],
              [-80.854836, 37.147366],
              [-80.881325, 37.17094],
              [-80.861748, 37.178379],
              [-80.871506, 37.19364900000011],
              [-80.894241, 37.17925600000012],
              [-81.014679, 37.275265],
              [-80.97855315187735, 37.29225271351237],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '1401451',
        DATE_GRANT: '2002-09-07',
        FILE_NUM: '0001016545',
        CALL_SIGN: 'KNKN776',
        MARKET: 'CMA684',
        BLOCK: 'A',
        DATE_CREAT: '2012-03-28',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.75663597119882, 37.42536050838862],
              [-79.677147, 37.48360800000012],
              [-79.658592, 37.484825000000114],
              [-79.6348339999999, 37.4571150000001],
              [-79.582985, 37.451771],
              [-79.559196, 37.49628800000016],
              [-79.54628, 37.489109],
              [-79.496872, 37.5367930000001],
              [-79.440926, 37.563393],
              [-79.457436, 37.599144],
              [-79.445229, 37.61803400000014],
              [-79.381607, 37.59174300000012],
              [-79.34265099999988, 37.518345000000124],
              [-79.293373, 37.499264],
              [-79.220398, 37.5056],
              [-79.209724, 37.477409],
              [-79.189316, 37.474911],
              [-79.2677, 37.447300000000155],
              [-79.272018, 37.436695],
              [-79.244797, 37.41980000000012],
              [-79.256882, 37.406433000000106],
              [-79.232254, 37.39481400000011],
              [-79.443138, 37.05572100000012],
              [-79.490906, 37.061161],
              [-79.458855, 37.018147],
              [-79.4809719999999, 37.005733000000134],
              [-79.55098, 37.052765000000136],
              [-79.542892, 37.044891],
              [-79.56456, 37.034595],
              [-79.594315, 37.04209500000013],
              [-79.715096, 36.541801],
              [-80.05369599999989, 36.54234700000012],
              [-80.058723, 36.66054500000013],
              [-80.094978, 36.74619300000012],
              [-80.095375, 36.778069],
              [-80.041725, 36.794228],
              [-80.077293, 36.830791],
              [-80.06668899999988, 36.840919],
              [-80.235687, 36.87199800000013],
              [-80.199104, 36.90137900000019],
              [-80.17543, 36.951206000000184],
              [-80.145691, 36.94929500000012],
              [-80.144173, 36.980057],
              [-80.121727, 36.99129900000014],
              [-80.130508, 37.006649],
              [-80.104652, 37.026314],
              [-80.11972, 37.049374],
              [-80.107903, 37.07313500000015],
              [-80.122734, 37.13156100000015],
              [-80.086166, 37.161884],
              [-80.0308, 37.17467500000015],
              [-79.96299, 37.136902000000134],
              [-79.9138339999999, 37.165043],
              [-79.883522, 37.209232],
              [-79.84242999999981, 37.23221600000011],
              [-79.847839, 37.30904],
              [-79.78891, 37.349247],
              [-79.775581, 37.377216000000146],
              [-79.81427, 37.403759],
              [-79.75663597119882, 37.42536050838862],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '7216190',
        DATE_GRANT: '2013-04-11',
        FILE_NUM: '0005560288',
        CALL_SIGN: 'KNKA242',
        MARKET: 'CMA014',
        BLOCK: 'A',
        DATE_CREAT: '2012-12-19',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.03930799966429, 39.47685499955861],
              [-76.05578899976246, 39.42192099965439],
              [-76.23645800003658, 39.304058999923086],
              [-76.34506800028794, 39.15170400043945],
              [-76.35099100003453, 39.04667299975927],
              [-76.42270500033544, 38.87096599988115],
              [-76.45726599962615, 38.71791499977758],
              [-76.6157530004005, 38.720511999929045],
              [-76.62339800041735, 38.76719999998011],
              [-76.69747199983289, 38.750000000000114],
              [-76.7137070002778, 38.77569999985508],
              [-76.70249899962903, 38.78879899957434],
              [-76.71230300028321, 38.81449900032868],
              [-76.69770099960135, 38.818298000152765],
              [-76.66999800000758, 38.903599000193765],
              [-76.69088700013492, 38.92440400004472],
              [-76.69850199966749, 38.9836009995866],
              [-76.7503049999757, 39.029899999685256],
              [-76.83820300016828, 39.073399000163874],
              [-76.82759900039349, 39.08980200026218],
              [-76.84979999987007, 39.10929900004891],
              [-76.88819899988391, 39.13164900010139],
              [-76.9590000003497, 39.13420099997626],
              [-76.95030200033699, 39.14359999994019],
              [-77.00180100011602, 39.17050200036715],
              [-77.00990299962359, 39.206798999674106],
              [-77.04510499969592, 39.23759799994781],
              [-77.13530700001786, 39.27170199974768],
              [-77.18710300000328, 39.33810000041473],
              [-77.10780299970861, 39.494301000091184],
              [-77.17079899997384, 39.5340999999151],
              [-77.1752009997262, 39.559798999724194],
              [-77.20060000008982, 39.578498999629176],
              [-77.21610300005335, 39.57440199955272],
              [-77.25622600042954, 39.60340499974109],
              [-77.26350399970977, 39.594199999730336],
              [-77.30970799992417, 39.63050100012123],
              [-77.2759020003769, 39.63190099993136],
              [-77.21720100032582, 39.71189900003901],
              [-76.24030300018313, 39.72129800000272],
              [-76.08630400042921, 39.5588989995893],
              [-76.03930799966429, 39.47685499955861],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '3611882',
        DATE_GRANT: '2006-08-26',
        FILE_NUM: '0002722071',
        CALL_SIGN: 'KNKA447',
        MARKET: 'CMA157',
        BLOCK: 'A',
        DATE_CREAT: '2012-12-21',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.66966925230042, 37.68608855851562],
              [-79.68383, 37.66153700000012],
              [-79.57338, 37.59538700000019],
              [-79.578262, 37.580761],
              [-79.4988019999999, 37.532753],
              [-79.50479899999988, 37.521099000000106],
              [-79.555412, 37.49892400000016],
              [-79.593941, 37.448757000000114],
              [-79.677147, 37.48360800000012],
              [-79.75702699999988, 37.424831],
              [-79.81427, 37.403759],
              [-79.779037, 37.370975],
              [-79.78891, 37.349247],
              [-79.844017, 37.318047],
              [-79.858307, 37.266998000000115],
              [-79.84242999999981, 37.23221600000011],
              [-79.95364399999988, 37.13961],
              [-80.00633199999987, 37.156719],
              [-80.008667, 37.172466000000156],
              [-80.086166, 37.161884],
              [-80.128357, 37.122776],
              [-80.172501, 37.108025],
              [-80.191246, 37.232487],
              [-80.258751, 37.308216],
              [-80.262215, 37.340565],
              [-80.328125, 37.366665],
              [-80.39718989271637, 37.32944710454774],
              [-80.41962461205318, 37.38581388141374],
              [-80.46037798409591, 37.39870367614426],
              [-80.475822, 37.42282500000016],
              [-80.300018, 37.508144],
              [-80.282608, 37.5333940000001],
              [-80.330528, 37.536121],
              [-80.31261399999988, 37.546116],
              [-80.32872, 37.5641940000001],
              [-80.2211989999999, 37.627644],
              [-80.144722, 37.596275000000105],
              [-80.032928, 37.660164],
              [-80.020744, 37.64733100000012],
              [-79.924454, 37.697559],
              [-79.8984622084597, 37.72744815059423],
              [-79.7327079999742, 37.7202170000146],
              [-79.68262299975163, 37.70951800035539],
              [-79.66966925230042, 37.68608855851562],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '1337008',
        DATE_GRANT: '2002-07-03',
        FILE_NUM: '0000946122',
        CALL_SIGN: 'KNKN715',
        MARKET: 'CMA682',
        BLOCK: 'A',
        DATE_CREAT: '2013-01-11',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-80.90410489524987, 37.052490369982024],
              [-80.740685, 36.878876000000105],
              [-81.04260299999987, 36.80630100000019],
              [-80.93285521440981, 36.671941150009786],
              [-80.9405829091574, 36.67853501742326],
              [-80.95002090984445, 36.65528501766954],
              [-80.92442990919801, 36.64410101743698],
              [-80.92103890936653, 36.62624501721615],
              [-80.91746790933155, 36.64506401776123],
              [-80.90583417187747, 36.639910608030675],
              [-80.838158, 36.55901300000011],
              [-81.677696, 36.58800100000013],
              [-81.61068, 36.617046],
              [-81.606003, 36.63859900000011],
              [-81.619301, 36.63420100000019],
              [-81.6996, 36.789501],
              [-81.836998, 36.928902000000164],
              [-81.71073790993307, 36.97581501804518],
              [-81.67363891030658, 36.93481501756111],
              [-81.48892291031126, 37.01553601802806],
              [-81.4688109095186, 37.015600017380905],
              [-81.48313390965757, 36.99021601818248],
              [-81.43381990993686, 37.006696017927084],
              [-81.38201490960341, 36.95502301738321],
              [-81.22544290922872, 37.047429017794684],
              [-81.17906490994926, 37.02526101755552],
              [-81.13248890963655, 37.03781501798795],
              [-81.1143189093305, 37.02261301779953],
              [-80.91671290960215, 37.07294801782018],
              [-80.90410489524987, 37.052490369982024],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '7563198',
        DATE_GRANT: '2013-05-08',
        FILE_NUM: '0005556224',
        CALL_SIGN: 'KNKN545',
        MARKET: 'CMA469',
        BLOCK: 'A',
        DATE_CREAT: '2012-05-08',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-77.46942900004825, 39.719924999639204],
              [-77.21710200025706, 39.719898000192586],
              [-77.21730000039469, 39.701801000216165],
              [-77.24320199967246, 39.69509899961918],
              [-77.24420199992227, 39.66989900033866],
              [-77.279105999742, 39.63610100026108],
              [-77.30970799992417, 39.63050100012123],
              [-77.29080200041193, 39.604198000337476],
              [-77.20060000008982, 39.578498999629176],
              [-77.1752009997262, 39.559798999724194],
              [-77.17079899997384, 39.5340999999151],
              [-77.10780299970861, 39.494301000091184],
              [-77.16999799990765, 39.35500000005004],
              [-77.45917500022603, 39.219723000316264],
              [-77.48710600044149, 39.2474819997945],
              [-77.54351800015547, 39.266834000089204],
              [-77.56211899999181, 39.30181099967808],
              [-77.67766599998583, 39.32419600044523],
              [-77.57025099998361, 39.61968599960937],
              [-77.52027899957613, 39.6408879997814],
              [-77.49317899991087, 39.67648700017497],
              [-77.5087050000356, 39.6840320000768],
              [-77.46942900004825, 39.719924999639204],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '7767902',
        DATE_GRANT: '2013-11-05',
        FILE_NUM: '0005903062',
        CALL_SIGN: 'KNKA693',
        MARKET: 'CMA262',
        BLOCK: 'A',
        DATE_CREAT: '2013-08-21',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-79.09899000028827, 37.034775000066304],
              [-79.21889499980432, 36.54150000002511],
              [-79.64975899957807, 36.54141699979476],
              [-79.69465100044329, 36.60381799960106],
              [-79.59431500043684, 37.042095000383995],
              [-79.56455999974418, 37.034594999859394],
              [-79.53824600035261, 37.049019000426654],
              [-79.48097199955805, 37.00573299987809],
              [-79.46127300034863, 37.01504500032655],
              [-79.48352100019395, 37.035182999995584],
              [-79.4794769998636, 37.064339000044924],
              [-79.40485400031179, 37.06354899958677],
              [-79.4049840000115, 37.09163699984771],
              [-79.37500000044963, 37.10047500002139],
              [-79.3826139999361, 37.11616100033001],
              [-79.34549699968676, 37.13349200005581],
              [-79.29766099975524, 37.104861999981495],
              [-79.25428000022174, 37.13275100005865],
              [-79.23693799998864, 37.10276400035838],
              [-79.22231300004478, 37.1012499997878],
              [-79.22232100041379, 37.11526500037951],
              [-79.20321699986454, 37.10657900002087],
              [-79.1933750001561, 37.05449700033637],
              [-79.18118299999543, 37.070552999721315],
              [-79.1176449999167, 37.08659000002859],
              [-79.09899000028827, 37.034775000066304],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8007523',
        DATE_GRANT: '2014-01-24',
        FILE_NUM: '0005912156',
        CALL_SIGN: 'KNKN662',
        MARKET: 'CMA691',
        BLOCK: 'A',
        DATE_CREAT: '2013-12-26',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-77.28650700019779, 38.346900999981244],
              [-77.32173899985492, 38.33816500001478],
              [-77.34784699963927, 38.27196899966975],
              [-77.32881199957404, 38.25245700009049],
              [-77.37059800019745, 38.24644900002153],
              [-77.64244099975218, 37.99102400035747],
              [-77.68759199997072, 38.00784299985463],
              [-77.79760700026276, 37.72915300021094],
              [-77.90013100044524, 37.76835300029086],
              [-77.94856299998241, 37.845916999669896],
              [-77.98841100026738, 37.856792000250664],
              [-78.017318999672, 37.89219699979185],
              [-78.30687699957383, 38.006259999699296],
              [-78.20836600009073, 38.13301500034214],
              [-78.37006399965384, 38.18462399979779],
              [-78.28713200004165, 38.27150699994826],
              [-78.33156599957113, 38.27101499974253],
              [-78.42775699998549, 38.3638079999393],
              [-78.43558500034743, 38.451312999995025],
              [-78.45319400030286, 38.47538400027145],
              [-78.44316099988015, 38.52763000032428],
              [-78.38133200037146, 38.561160999780384],
              [-78.38607000033022, 38.58250800034409],
              [-78.33859299986693, 38.6271589999879],
              [-78.23188800023092, 38.53209700037644],
              [-78.17882500027349, 38.52649300005203],
              [-77.93599699966177, 38.695563999678996],
              [-77.90553999987105, 38.69469500007426],
              [-77.86195399987713, 38.62179199980102],
              [-77.87571699963979, 38.589885999739124],
              [-77.8608320002964, 38.56161099984786],
              [-77.80096400038826, 38.51116600011079],
              [-77.73616799985314, 38.413417999840874],
              [-77.69855500011306, 38.42555200002488],
              [-77.63947299957925, 38.40923300020279],
              [-77.63321699976461, 38.46323000006464],
              [-77.47730299983351, 38.59220100037601],
              [-77.3702009998762, 38.51931399994123],
              [-77.29970600003179, 38.50310099961155],
              [-77.32069400022789, 38.435100999711494],
              [-77.28650700019779, 38.346900999981244],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8127533',
        DATE_GRANT: '2014-03-25',
        FILE_NUM: '0006140281',
        CALL_SIGN: 'KNKA761',
        MARKET: 'CMA235',
        BLOCK: 'A',
        DATE_CREAT: '2014-02-11',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.97275499974342, 37.248351999845056],
              [-77.15624999993747, 37.113819000246735],
              [-77.6193240003023, 36.877697000416276],
              [-77.7154769998636, 36.91465799976697],
              [-77.76582300043106, 36.97450599965231],
              [-77.88685599980448, 36.988091000199574],
              [-77.90062699993604, 37.14377999964745],
              [-77.8169019997274, 37.16799899955436],
              [-77.79440299999828, 37.19508699956543],
              [-77.7601169998996, 37.19243100029047],
              [-77.68204300038411, 37.292063000207406],
              [-77.65090699985814, 37.265055000288044],
              [-77.60356900040898, 37.26376300006251],
              [-77.55910500039533, 37.224491000259604],
              [-77.43419600034508, 37.22449899972912],
              [-77.41680100036581, 37.233001999742555],
              [-77.42490399991954, 37.28350100017116],
              [-77.4061969996917, 37.27379999977029],
              [-77.37309999956528, 37.296799000073804],
              [-77.36293000001945, 37.28136100040996],
              [-77.39099900030357, 37.24052000019799],
              [-77.35281400026582, 37.310016999884795],
              [-77.27097299970416, 37.32060599986704],
              [-77.25001499999217, 37.30848700037495],
              [-77.09793899988489, 37.31182499962421],
              [-77.069739999901, 37.26959600015539],
              [-77.0092239997876, 37.30522900031815],
              [-76.97275499974342, 37.248351999845056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8139474',
        DATE_GRANT: '2014-03-28',
        FILE_NUM: '0006156651',
        CALL_SIGN: 'KNKA243',
        MARKET: 'CMA008',
        BLOCK: 'A',
        DATE_CREAT: '2014-02-18',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.66283399968927, 38.52536800033306],
              [-76.68696600008076, 38.494869000404094],
              [-76.76866100020493, 38.51253100010564],
              [-76.85094499961201, 38.39778500017769],
              [-76.87216199957652, 38.389056999680975],
              [-76.84808299983052, 38.35565199974019],
              [-76.81543299963317, 38.230564999575165],
              [-76.86816300042204, 38.1755620000863],
              [-76.96262400019737, 38.217159000087975],
              [-76.96245599964459, 38.25635499998333],
              [-77.0274579997868, 38.304611000397415],
              [-77.01621200008367, 38.3708989995892],
              [-77.04258699959024, 38.400817999750984],
              [-77.085236000441, 38.36829399996816],
              [-77.26559399986314, 38.333038000103784],
              [-77.28650700019779, 38.346900999981244],
              [-77.32330300003332, 38.43333099992577],
              [-77.29970600003179, 38.50310099961155],
              [-77.3702009998762, 38.51931399994123],
              [-77.47139699997155, 38.58890200022722],
              [-77.48730499972584, 38.591800999916245],
              [-77.53119700034114, 38.55580099991636],
              [-77.71570599963206, 38.832099999915215],
              [-77.6553650003944, 38.94252400018257],
              [-77.96232599974502, 39.013645000116696],
              [-77.86264800040482, 39.08095899985807],
              [-77.75000000009982, 39.290398000367475],
              [-77.71931499968741, 39.32102599995005],
              [-77.56688700043463, 39.30601900037675],
              [-77.54351800015547, 39.266834000089204],
              [-77.4594419999483, 39.227322000010474],
              [-77.16819799963793, 39.35419799993781],
              [-77.1841050002455, 39.345355999579795],
              [-77.16480299955873, 39.30740000021001],
              [-77.11540200030197, 39.26520200037214],
              [-77.04510499969592, 39.23759799994781],
              [-77.00990299962359, 39.206798999674106],
              [-77.00859799969788, 39.18080099956654],
              [-76.95190399956982, 39.146000000000186],
              [-76.9590000003497, 39.13420099997626],
              [-76.88819899988391, 39.13164900010139],
              [-76.82790400006951, 39.09400199969252],
              [-76.83590700040764, 39.06800100034587],
              [-76.75610400029927, 39.03770099970154],
              [-76.69850199966749, 38.9836009995866],
              [-76.69088700013492, 38.92440400004472],
              [-76.67079900007377, 38.90719999988016],
              [-76.71209699977669, 38.784401000006255],
              [-76.68433400011389, 38.73823199960708],
              [-76.70227099990666, 38.71074700017408],
              [-76.6872939999181, 38.68051900015172],
              [-76.69957699977869, 38.67099399977343],
              [-76.67264599981297, 38.61741600034827],
              [-76.68101499994225, 38.58037900019082],
              [-76.66283399968927, 38.52536800033306],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8141842',
        DATE_GRANT: '2014-03-28',
        FILE_NUM: '0006156734',
        CALL_SIGN: 'KNKA570',
        MARKET: 'CMA269',
        BLOCK: 'A',
        DATE_CREAT: '2014-02-18',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.5306809997283, 39.633424000017726],
              [-78.54160900005525, 39.56866400024347],
              [-78.56971400020092, 39.52131200014878],
              [-78.65792100025385, 39.53508400032638],
              [-78.7301029996537, 39.46311199981892],
              [-78.77372000017778, 39.44277199982798],
              [-78.8109439999655, 39.37653000005952],
              [-78.86716499986477, 39.3258900003234],
              [-78.88141599964865, 39.32572900009336],
              [-78.86627500019108, 39.38209999971531],
              [-78.88811400006102, 39.455154999803426],
              [-78.96620699955326, 39.512959999904126],
              [-79.04128100011798, 39.52977199997798],
              [-79.0167490001661, 39.572857000250394],
              [-79.00880599989694, 39.685979999977064],
              [-78.98605000000742, 39.722417000344365],
              [-78.91705700018036, 39.72270700022801],
              [-78.82479600023515, 39.77712000038787],
              [-78.7936019997324, 39.76549600034019],
              [-78.80863999983598, 39.72282800041194],
              [-78.54640299989848, 39.72268800025114],
              [-78.5306809997283, 39.633424000017726],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8154008',
        DATE_GRANT: '2014-04-01',
        FILE_NUM: '0006166830',
        CALL_SIGN: 'KNKA779',
        MARKET: 'CMA257',
        BLOCK: 'A',
        DATE_CREAT: '2014-02-21',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.31290299957374, 39.62963999998618],
              [-78.34357500028597, 39.67509499983436],
              [-78.32025899975292, 39.67637999973732],
              [-78.31366000030863, 39.6917719999779],
              [-78.34380300000839, 39.71749900017886],
              [-77.46942900004825, 39.719924999639204],
              [-77.50349399984816, 39.689262000241115],
              [-77.49317899991087, 39.67648700017497],
              [-77.52027899957613, 39.6408879997814],
              [-77.57025099998361, 39.61968599960937],
              [-77.62277200012767, 39.5074159996488],
              [-77.61656199973646, 39.468554999913295],
              [-77.67632100001407, 39.331434999725616],
              [-77.76139799961788, 39.33965700027039],
              [-77.74621600006827, 39.35311899964216],
              [-77.75356299983252, 39.3782199997533],
              [-77.74029500041388, 39.40159600035514],
              [-77.75337200001769, 39.42316400031842],
              [-77.80353500023995, 39.43703499966557],
              [-77.78075400009686, 39.45976600020077],
              [-77.79592099985422, 39.471160999580604],
              [-77.78880299985849, 39.48495099968898],
              [-77.76738000028666, 39.49123800003383],
              [-77.84539000044805, 39.49818800037599],
              [-77.82563799969387, 39.529079000395654],
              [-77.86395999975417, 39.51493500015033],
              [-77.86563100037034, 39.53828400040641],
              [-77.88890099968137, 39.55482499967411],
              [-77.8335040000095, 39.57091899991207],
              [-77.8323289997835, 39.60136800023315],
              [-77.88540600038658, 39.615681000178085],
              [-77.89064800020498, 39.59745799978691],
              [-77.93286099983521, 39.6173550000334],
              [-77.94513700027227, 39.615620000063075],
              [-77.93827100020644, 39.58881799975097],
              [-77.96662099995916, 39.60737999958735],
              [-78.00388299970064, 39.600552000374705],
              [-78.0777969998316, 39.668789000412175],
              [-78.17607100007643, 39.69588900007733],
              [-78.22760000033969, 39.676032999923166],
              [-78.26535799957196, 39.61917899961128],
              [-78.31290299957374, 39.62963999998618],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8154142',
        DATE_GRANT: '2014-04-01',
        FILE_NUM: '0006166836',
        CALL_SIGN: 'KNKN938',
        MARKET: 'CMA467',
        BLOCK: 'A',
        DATE_CREAT: '2014-02-21',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.86603099973081, 39.35822000015304],
              [-78.92687200044242, 39.27876699999723],
              [-78.9801480003299, 39.237517999855925],
              [-79.1347049997359, 39.31240099970648],
              [-79.27207899994579, 39.32774699962437],
              [-79.29085499975832, 39.29901500024221],
              [-79.332198999784, 39.29997599959273],
              [-79.440056000384, 39.21696900011932],
              [-79.48709899971897, 39.205856000254244],
              [-79.47690600001175, 39.721000999796445],
              [-79.39270000010481, 39.721500000324795],
              [-79.41020199962247, 39.734900999581555],
              [-79.37890599981199, 39.76879899977416],
              [-79.39190700040763, 39.7779010004308],
              [-79.31108900025708, 39.72184400000066],
              [-78.98595800026146, 39.72255000018254],
              [-79.00880599989694, 39.685979999977064],
              [-79.01678500002765, 39.572959999604336],
              [-79.04128100011798, 39.52977199997798],
              [-78.9178109998777, 39.48504899971164],
              [-78.87871400005099, 39.43748199959475],
              [-78.86603099973081, 39.35822000015304],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8208829',
        DATE_GRANT: '2014-05-06',
        FILE_NUM: '0006050507',
        CALL_SIGN: 'KNKN622',
        MARKET: 'CMA688',
        BLOCK: 'A',
        DATE_CREAT: '2014-03-19',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-77.65613599997636, 36.713390000148365],
              [-77.74696000020373, 36.57616999984566],
              [-77.7230039998347, 36.55154500010178],
              [-77.7529100002962, 36.545253999572594],
              [-78.61334999980255, 36.541266000025985],
              [-78.64459600000532, 36.5170300002344],
              [-78.74071499979732, 36.55074299998961],
              [-78.71888000011182, 36.57599599991562],
              [-78.6973110001025, 36.67897400034991],
              [-78.65007800009954, 36.69012800030697],
              [-78.61444099975222, 36.6633490001563],
              [-78.63976300016225, 36.69422100019909],
              [-78.596659999959, 36.762606999913146],
              [-78.61536099991008, 36.84845199985995],
              [-78.57138399987161, 36.87258400025149],
              [-78.51892699998092, 36.866886000088925],
              [-78.49330900031009, 36.89107500041098],
              [-78.44358799978625, 37.07916999959588],
              [-78.33189200021559, 37.10226799996832],
              [-78.2428189997969, 37.15473300022791],
              [-78.23151400007094, 37.29608500042258],
              [-78.2408829995507, 37.3766980001127],
              [-78.1853180002255, 37.44426699992226],
              [-78.1404650002595, 37.459309000210226],
              [-78.09877000023528, 37.440666000235694],
              [-78.04806500019953, 37.4726749996517],
              [-78.01769299983204, 37.4711799999572],
              [-77.99999999960028, 37.49784500024657],
              [-77.89907100012653, 37.47487300028888],
              [-77.88703199982683, 37.449058999673184],
              [-77.87499999985005, 37.45718800042607],
              [-77.85636100005996, 37.431903999969734],
              [-77.87204000004584, 37.41821700011451],
              [-77.87712099963437, 37.364552000274614],
              [-77.83799700036121, 37.33820300016839],
              [-77.79777499991621, 37.333565000324654],
              [-77.8073119999487, 37.304942999719685],
              [-77.76798200016907, 37.274714999697494],
              [-77.7460939998382, 37.26669699956699],
              [-77.71651500006715, 37.29654299995957],
              [-77.69511699984957, 37.28503399981929],
              [-77.7590759995577, 37.19329100037942],
              [-77.79440299999828, 37.19508699956543],
              [-77.8169019997274, 37.16799899955436],
              [-77.90062699993604, 37.14377999964745],
              [-77.8900909996998, 36.98866699978237],
              [-77.84011099982274, 36.99576599980111],
              [-77.7720639995539, 36.97613099994578],
              [-77.72808799956147, 36.94322999986463],
              [-77.7154769998636, 36.91465799976697],
              [-77.66587799956994, 36.89532500034858],
              [-77.65613599997636, 36.713390000148365],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8241184',
        DATE_GRANT: '2014-04-11',
        FILE_NUM: '0006156639',
        CALL_SIGN: 'KNKN838',
        MARKET: 'CMA690',
        BLOCK: 'A',
        DATE_CREAT: '2014-04-08',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.86953000010931, 38.762878000319574],
              [-78.78627800012953, 38.887077000003615],
              [-78.73918200014913, 38.92717400008007],
              [-78.72270999956675, 38.93129699955705],
              [-78.72119099966488, 38.910048999961475],
              [-78.67788700008492, 38.927605000170615],
              [-78.6280670003917, 38.98168200012435],
              [-78.60192099975427, 38.96449699993667],
              [-78.55073500002021, 39.01796000035381],
              [-78.57216599996087, 39.03188699958554],
              [-78.40396900016913, 39.167346999664346],
              [-78.43891900031156, 39.197947999800476],
              [-78.40585299981592, 39.23107500041107],
              [-78.41969300043161, 39.25737800019459],
              [-78.33923299970314, 39.34979200000083],
              [-78.36713400033375, 39.359192000010864],
              [-78.34349100000958, 39.38870600038166],
              [-78.35822300039109, 39.40409499958474],
              [-78.34541299961018, 39.459388999902615],
              [-77.82843800021351, 39.132224999683956],
              [-77.86264800040482, 39.08095899985807],
              [-77.9557880004158, 39.02052299983666],
              [-77.6553650003944, 38.94252400018257],
              [-77.71570599963206, 38.832099999915215],
              [-77.53119700034114, 38.55580099991636],
              [-77.63321699976461, 38.46323000006464],
              [-77.63563499975527, 38.40968699955539],
              [-77.69043699986753, 38.42688000011202],
              [-77.73616799985314, 38.413417999840874],
              [-77.81401799983075, 38.53012800040699],
              [-77.87638900005226, 38.58432399955302],
              [-77.86174800026987, 38.61369699971692],
              [-77.8776400001858, 38.63084800013519],
              [-77.8718260000698, 38.648205000160715],
              [-77.89726999981053, 38.6619150001772],
              [-77.90553999987105, 38.69469500007426],
              [-77.92842100012899, 38.69863099992085],
              [-78.09041599989843, 38.59666400024349],
              [-78.17029599996027, 38.52273600036625],
              [-78.23188800023092, 38.53209700037644],
              [-78.33859299986693, 38.6271589999879],
              [-78.38359799964786, 38.58816899969975],
              [-78.38935099964885, 38.55475200010471],
              [-78.40969699991655, 38.54931999961832],
              [-78.4203730003137, 38.56306100016519],
              [-78.45530000029476, 38.54843800031364],
              [-78.4850899999035, 38.43995799976199],
              [-78.54904200018814, 38.42639500022926],
              [-78.55461900016661, 38.4426879997514],
              [-78.62316900024905, 38.46563700044726],
              [-78.63079100010452, 38.494900000035045],
              [-78.6915659995712, 38.50988400034652],
              [-78.64730800006407, 38.60191000024639],
              [-78.86953000010931, 38.762878000319574],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8267524',
        DATE_GRANT: '2014-05-07',
        FILE_NUM: '0006173729',
        CALL_SIGN: 'KNKA330',
        MARKET: 'CMA043',
        BLOCK: 'A',
        DATE_CREAT: '2014-04-23',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-75.77375000036221, 36.23159399976339],
              [-75.78775000026224, 36.22870599968218],
              [-75.82189200001574, 36.292441999898415],
              [-75.85704799976531, 36.42504899971169],
              [-75.88647499972137, 36.43918599963422],
              [-75.89946699990202, 36.47243499957574],
              [-75.9395900002782, 36.4896320003167],
              [-76.00417299998395, 36.493450000117605],
              [-76.02289600005031, 36.46593900038454],
              [-76.00761400038573, 36.443394000333],
              [-75.93118300019529, 36.42849000011347],
              [-75.91513800041832, 36.35090999999659],
              [-75.79880500015054, 36.112038000153746],
              [-75.79618099965336, 36.07006499990001],
              [-75.84689300001185, 36.10067000022036],
              [-75.88794700015387, 36.154400000359715],
              [-76.01103900004978, 36.17038800020606],
              [-75.96898799979624, 36.25653499969059],
              [-75.97138199957953, 36.30822800032206],
              [-75.99139399973325, 36.30810900023033],
              [-76.03727000011037, 36.35520600025683],
              [-76.11489899978886, 36.3572920002257],
              [-76.15799000033815, 36.39806399995376],
              [-76.15890500026552, 36.42612800000717],
              [-76.3135530002707, 36.55040000035984],
              [-76.93125899990287, 36.55941799984089],
              [-76.91276599965101, 36.57694200037315],
              [-76.8979800003766, 36.64385200036958],
              [-76.53385199976992, 36.91541699969497],
              [-76.50208299973053, 36.91349400004816],
              [-76.4904480000751, 36.927536000086434],
              [-76.47020700015287, 36.89686999965073],
              [-76.43983499978538, 36.90621199968422],
              [-76.3875050003553, 36.894996999611976],
              [-76.38609299999183, 36.923500000125046],
              [-76.3309630000424, 36.92490400011968],
              [-76.3253559995797, 36.96274899976669],
              [-76.30154399955592, 36.95575300000104],
              [-76.28505700008043, 36.968571000251586],
              [-76.09583300009285, 36.9079279996775],
              [-76.01410700033773, 36.930599000143786],
              [-75.99160000023977, 36.90950000022502],
              [-75.94990500021555, 36.761001999642644],
              [-75.87450399985966, 36.58369799986298],
              [-75.77375000036221, 36.23159399976339],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8320187',
        DATE_GRANT: '2014-05-23',
        FILE_NUM: '0006188471',
        CALL_SIGN: 'KNKA433',
        MARKET: 'CMA104',
        BLOCK: 'A',
        DATE_CREAT: '2014-05-19',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.27114899992637, 37.08470500033553],
              [-76.31227099960682, 36.99966399969395],
              [-76.32209000005344, 37.011344999672076],
              [-76.35246299956765, 37.00523800043351],
              [-76.41133100012541, 36.963214999672516],
              [-76.4578020000622, 36.9613950002792],
              [-76.62852500032847, 37.09260899970576],
              [-76.64614099970731, 37.12500800001931],
              [-76.64399699976167, 37.190192999607405],
              [-76.66076699969722, 37.203998999554244],
              [-76.70595599986945, 37.206286999845304],
              [-76.74387400018486, 37.171023999657905],
              [-76.80924999958779, 37.22219799973806],
              [-76.8834690002941, 37.2229080001041],
              [-76.8738249998238, 37.363269999610964],
              [-76.91593900028454, 37.35372500010868],
              [-76.89810199970742, 37.37365700017051],
              [-76.89626300033717, 37.427853000215975],
              [-76.8239520003844, 37.4505839998518],
              [-76.76462600028958, 37.43689299981213],
              [-76.7423019996375, 37.4669300000196],
              [-76.73533000007939, 37.45392400009263],
              [-76.66248299969061, 37.457660999755376],
              [-76.64814799963045, 37.49549099961001],
              [-76.66793100001553, 37.520240999722546],
              [-76.6544040003443, 37.60303099998072],
              [-76.43789700034625, 37.514225000183615],
              [-76.45223999987599, 37.484077000253535],
              [-76.44827300039861, 37.419925999785164],
              [-76.41613699962272, 37.4141139997613],
              [-76.40997599969256, 37.37375800033146],
              [-76.46184600039254, 37.38701700023449],
              [-76.46714400009546, 37.365565000224706],
              [-76.40554500040128, 37.337980999823344],
              [-76.41541000027127, 37.322113000114996],
              [-76.43786899995428, 37.3226309997209],
              [-76.41829900039846, 37.30760700026303],
              [-76.39408699991509, 37.313279000125874],
              [-76.3818739996853, 37.29176299986267],
              [-76.38428500025248, 37.17042199977561],
              [-76.34674100009704, 37.16970399993966],
              [-76.29791999970809, 37.13040899997554],
              [-76.27114899992637, 37.08470500033553],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8403390',
        DATE_GRANT: '2014-07-17',
        FILE_NUM: '0006195324',
        CALL_SIGN: 'KNKN567',
        MARKET: 'CMA704',
        BLOCK: 'A',
        DATE_CREAT: '2014-07-02',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-77.67632100001407, 39.331434999725616],
              [-77.73518400034129, 39.31230899996052],
              [-77.82246399991362, 39.13988100020799],
              [-78.34735900031751, 39.465915999623746],
              [-78.35822300039109, 39.40409499958474],
              [-78.34349100000958, 39.38870600038166],
              [-78.36713400033375, 39.359192000010864],
              [-78.340751999605, 39.35339399973327],
              [-78.41969300043161, 39.25737800019459],
              [-78.40013100034531, 39.2441750001762],
              [-78.43891900031156, 39.197947999800476],
              [-78.40396900016913, 39.167346999664346],
              [-78.57216599996087, 39.03188699958554],
              [-78.55073500002021, 39.01796000035381],
              [-78.59915900008775, 38.96943700021751],
              [-78.62071999972818, 38.982490999659944],
              [-78.69769299973211, 38.91424900029125],
              [-78.7174380001635, 38.904186000283744],
              [-78.71733900009474, 38.93592099965451],
              [-78.77945700034024, 38.892189000122244],
              [-78.86953000010931, 38.762878000319574],
              [-78.99424700029874, 38.849991000284604],
              [-79.02330799956445, 38.79849999997515],
              [-79.05519899983392, 38.78559900039363],
              [-79.08750200021711, 38.72000099974639],
              [-79.09250599985188, 38.66799900015377],
              [-79.12250500010555, 38.65969799956321],
              [-79.14718999991851, 38.62738399957203],
              [-79.11407299976895, 38.564199999630375],
              [-79.16347399992515, 38.48318899957286],
              [-79.17391100009246, 38.56687699987373],
              [-79.24288199980441, 38.45404400003076],
              [-79.31251500036689, 38.41175100030847],
              [-79.4768750003808, 38.457108000134156],
              [-79.52170600023169, 38.534000000000106],
              [-79.63503799970385, 38.58615799959216],
              [-79.60680800008896, 38.62952700037084],
              [-79.60170699957825, 38.678599999790265],
              [-79.50980399995461, 38.78819999983028],
              [-79.53910100021096, 38.8422009998763],
              [-79.51039900041349, 38.873699000009026],
              [-79.5187990001736, 38.88429999964541],
              [-79.44470199969749, 38.898498999729156],
              [-79.45570399983967, 38.92979799967799],
              [-79.37510699998802, 38.92070000010506],
              [-79.30432100021392, 39.0464439999908],
              [-79.29840099970636, 39.073105000095836],
              [-79.35570500008566, 39.08639899981415],
              [-79.33153499974043, 39.11873199978203],
              [-79.33180200036196, 39.14849900012882],
              [-79.29699699971167, 39.18840000015996],
              [-79.30970800042383, 39.210898999889025],
              [-79.46320300031812, 39.182098000022734],
              [-79.48709899971897, 39.205856000254244],
              [-79.43241100036732, 39.22422400013767],
              [-79.332198999784, 39.29997599959273],
              [-79.29085499975832, 39.29901500024221],
              [-79.27207899994579, 39.32774699962437],
              [-79.1347049997359, 39.31240099970648],
              [-78.9801480003299, 39.237517999855925],
              [-78.8835910001244, 39.328612999990014],
              [-78.85115800004155, 39.33076899958985],
              [-78.76685300006585, 39.44737599990248],
              [-78.7301029996537, 39.46311199981892],
              [-78.65792100025385, 39.53508400032638],
              [-78.47444900022111, 39.51614800033008],
              [-78.4504699996906, 39.53811299971528],
              [-78.46042600015971, 39.54588700028495],
              [-78.42441599969857, 39.54509000040326],
              [-78.45745799998662, 39.58728800024113],
              [-78.39558400020127, 39.58412600011485],
              [-78.43327299984901, 39.61642799955257],
              [-78.42616999964571, 39.6244540000522],
              [-78.38385799994666, 39.60882200043511],
              [-78.35690299977358, 39.6402819997146],
              [-78.26535799957196, 39.61917899961128],
              [-78.22454099956735, 39.65965700017051],
              [-78.2332760003871, 39.67038000003703],
              [-78.17607100007643, 39.69588900007733],
              [-78.0777969998316, 39.668789000412175],
              [-78.01162699978619, 39.603988999692774],
              [-77.95438400042121, 39.60759399956345],
              [-77.94551100043225, 39.58454100036698],
              [-77.94513700027227, 39.615620000063075],
              [-77.89064800020498, 39.59745799978691],
              [-77.88540600038658, 39.615681000178085],
              [-77.83885999968919, 39.60622000005304],
              [-77.8335040000095, 39.57091899991207],
              [-77.88890099968137, 39.55482499967411],
              [-77.86563100037034, 39.53828400040641],
              [-77.86679800022745, 39.51993899978504],
              [-77.82563799969387, 39.529079000395654],
              [-77.8483890002521, 39.50199499966959],
              [-77.76866100000507, 39.49764300042415],
              [-77.7980730001687, 39.4786640002435],
              [-77.77809899996885, 39.46182299973168],
              [-77.79344199974832, 39.461944999961815],
              [-77.78586600021572, 39.4452669997724],
              [-77.80114699983409, 39.44074199974352],
              [-77.75337200001769, 39.42316400031842],
              [-77.74029500041388, 39.40159600035514],
              [-77.73619100001463, 39.389565000424454],
              [-77.75367000027023, 39.381996000315326],
              [-77.74621600006827, 39.35311899964216],
              [-77.75959800024748, 39.345215000272105],
              [-77.67632100001407, 39.331434999725616],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8511026',
        DATE_GRANT: '2014-11-03',
        FILE_NUM: '0006432802',
        CALL_SIGN: 'KNKR271',
        MARKET: 'CMA269',
        BLOCK: 'A',
        DATE_CREAT: '2014-08-21',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.56971400020092, 39.52131200014878],
              [-78.53293500025, 39.611617999870816],
              [-78.5437119999088, 39.71430500037553],
              [-78.34278099964331, 39.72245000006751],
              [-78.3183899998985, 39.701996000215274],
              [-78.32025899975292, 39.67637999973732],
              [-78.33692200015003, 39.68044700022887],
              [-78.31336200005615, 39.63162799993239],
              [-78.35690299977358, 39.6402819997146],
              [-78.38385799994666, 39.60882200043511],
              [-78.432289000337, 39.62198599955434],
              [-78.39773599961666, 39.59014099960763],
              [-78.40829500001422, 39.578498999629176],
              [-78.45745799998662, 39.58728800024113],
              [-78.41767900018556, 39.54812600011496],
              [-78.46188399994656, 39.55032299980667],
              [-78.4504699996906, 39.543555999809655],
              [-78.46890299987354, 39.51669699956693],
              [-78.56971400020092, 39.52131200014878],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8594602',
        DATE_GRANT: '2014-10-06',
        FILE_NUM: '0006413497',
        CALL_SIGN: 'KNKA350',
        MARKET: 'CMA059',
        BLOCK: 'A',
        DATE_CREAT: '2014-10-03',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.7423019996375, 37.4669300000196],
              [-76.77719900003376, 37.4337119997092],
              [-76.8239520003844, 37.4505839998518],
              [-76.89626300033717, 37.427853000215975],
              [-76.89247900030551, 37.383236000341185],
              [-76.91593900028454, 37.35372500010868],
              [-76.8738249998238, 37.363269999610964],
              [-76.8834690002941, 37.2229080001041],
              [-76.97275499974342, 37.248351999845056],
              [-76.99122599987993, 37.29618799977652],
              [-77.0092239997876, 37.30522900031815],
              [-77.069739999901, 37.26959600015539],
              [-77.08855399966728, 37.312922999896614],
              [-77.12542000003293, 37.302773000373804],
              [-77.27097299970416, 37.32060599986704],
              [-77.35281400026582, 37.310016999884795],
              [-77.38970199984738, 37.23789999988509],
              [-77.36293000001945, 37.28136100040996],
              [-77.36850699999803, 37.298401000206184],
              [-77.39870500043537, 37.2723009998914],
              [-77.431998999754, 37.27619899978407],
              [-77.41680100036581, 37.233001999742555],
              [-77.52268199977442, 37.21686900040419],
              [-77.55910500039533, 37.224491000259604],
              [-77.61283100035035, 37.27046599980622],
              [-77.6431580004413, 37.2635839999017],
              [-77.66775499979337, 37.29232000036774],
              [-77.69284800043482, 37.28130000029495],
              [-77.71651500006715, 37.29654299995957],
              [-77.74014299969957, 37.26827600043714],
              [-77.76397699983858, 37.270824000127675],
              [-77.8073119999487, 37.304942999719685],
              [-77.79645500019808, 37.324024000107556],
              [-77.87449599999024, 37.3622130003298],
              [-77.87551900040148, 37.41668300042028],
              [-77.85901600018815, 37.414398000267624],
              [-77.85636100005996, 37.431903999969734],
              [-77.87499999985005, 37.45718800042607],
              [-77.89790300022327, 37.457072999619356],
              [-77.89464600021267, 37.47050100012109],
              [-77.99999999960028, 37.49784500024657],
              [-78.01769299983204, 37.4711799999572],
              [-78.11669899965904, 37.44469099968995],
              [-78.1253999998101, 37.463167000057126],
              [-78.09881300041957, 37.584434000329],
              [-78.13536699988708, 37.69496300004249],
              [-78.1023210003138, 37.716324000352415],
              [-78.15665100024341, 37.756945000311646],
              [-78.071631999717, 37.90840499989088],
              [-78.017318999672, 37.89219699979185],
              [-77.98841100026738, 37.856792000250664],
              [-77.94856299998241, 37.845916999669896],
              [-77.88869500007411, 37.7606009998363],
              [-77.8336789999858, 37.75339500027923],
              [-77.79760700026276, 37.72915300021094],
              [-77.68759199997072, 38.00784299985463],
              [-77.64836100025985, 37.993927000231054],
              [-77.61445599974445, 37.95925899960332],
              [-77.57634699961432, 37.958133999884296],
              [-77.54621100023735, 37.928204000114704],
              [-77.5574189999868, 37.923470000340274],
              [-77.52919799988769, 37.920811000027754],
              [-77.48403199987683, 37.88330499982601],
              [-77.44502999993443, 37.89459199962124],
              [-77.41888400019639, 37.8603360000065],
              [-77.42748999956382, 37.826290000183405],
              [-77.39562999982462, 37.803309999856765],
              [-77.40608199978442, 37.781852999616376],
              [-77.33207699995353, 37.79224000017592],
              [-77.3222960003601, 37.77006900028431],
              [-77.33468599975896, 37.75448200004445],
              [-77.30414599973807, 37.75515399955759],
              [-77.32281500001221, 37.733604000424464],
              [-77.2937470004237, 37.7399220004001],
              [-77.2925639998287, 37.71428699994527],
              [-77.26983600033111, 37.7235760002323],
              [-77.24936699978713, 37.70924000012599],
              [-77.23708299988044, 37.72666199955165],
              [-77.24220999979156, 37.68834699981426],
              [-77.18360100038569, 37.685534999640595],
              [-77.18586000023873, 37.6574939997484],
              [-77.14949799973283, 37.674099000168724],
              [-77.1103439999755, 37.66329600021032],
              [-77.12396200024608, 37.626739999751294],
              [-77.08043700036723, 37.59645099961409],
              [-77.01956900020912, 37.58355700035537],
              [-77.01284799963543, 37.56415899973803],
              [-76.98330699981807, 37.56535700012546],
              [-76.99309499973435, 37.57716399961896],
              [-76.9764019997524, 37.58578899986259],
              [-76.95736699968717, 37.57177700030849],
              [-76.97425799980681, 37.54709599978054],
              [-76.9532779999796, 37.53564100033202],
              [-76.92052500042837, 37.569099000018866],
              [-76.90750900004025, 37.5684780001597],
              [-76.9056240003473, 37.54879399984327],
              [-76.87621300022965, 37.55170400003959],
              [-76.88237800034437, 37.576274999991426],
              [-76.85873399997405, 37.579361000209985],
              [-76.87701400029584, 37.536278000029824],
              [-76.86415099976881, 37.52308300038027],
              [-76.82724000002594, 37.55074699997408],
              [-76.7423019996375, 37.4669300000196],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8600536',
        DATE_GRANT: '2014-10-08',
        FILE_NUM: '0006397554',
        CALL_SIGN: 'KNKQ436',
        MARKET: 'CMA468',
        BLOCK: 'A',
        DATE_CREAT: '2014-10-07',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-74.98628199981442, 38.451585999993995],
              [-75.02080500005059, 38.30975600023919],
              [-75.13519999997999, 38.07446900024428],
              [-75.2090859997191, 37.98039899961424],
              [-75.23689399965826, 38.03523300030275],
              [-75.62469500017403, 37.99408700041482],
              [-75.6480479997154, 37.946837999674074],
              [-75.70498700034972, 37.95457500033609],
              [-75.79113499988023, 37.9120669996924],
              [-75.89672500025853, 37.90901300005004],
              [-75.94872099957445, 37.831833000392805],
              [-76.01921700036422, 37.85457100035143],
              [-76.07187799976981, 37.92362300020142],
              [-76.08497999962725, 37.99250000007498],
              [-76.03922000010289, 38.060928999973385],
              [-76.03929900014867, 38.13332999957987],
              [-76.08881200007369, 38.17816899979965],
              [-76.1234090001252, 38.25340000040978],
              [-76.13109700032618, 38.157231000110755],
              [-76.10428400040627, 38.081301999687696],
              [-76.14465799976682, 37.97912400017259],
              [-76.15999600021519, 38.011353999887376],
              [-76.22970699987803, 38.05934000044073],
              [-76.3266039995749, 38.029781999839486],
              [-76.51810700033775, 38.04842899999841],
              [-76.59645099971374, 38.106766000350774],
              [-76.61432600024466, 38.14271899998187],
              [-76.86911800039536, 38.17153899982503],
              [-76.81543299963317, 38.230564999575165],
              [-76.85254699974422, 38.3679890002922],
              [-76.87397000021531, 38.379447999925446],
              [-76.82300599992686, 38.42825699976089],
              [-76.77523800043326, 38.50880099986625],
              [-76.71222700037566, 38.50988000016196],
              [-76.68696600008076, 38.494869000404094],
              [-76.66283399968927, 38.52536800033306],
              [-76.67577400016984, 38.53575499999323],
              [-76.67264599981297, 38.61741600034827],
              [-76.69316900014923, 38.63631799967601],
              [-76.68418100025286, 38.6620560003841],
              [-76.69748699962531, 38.66454700014401],
              [-76.70227099990666, 38.71074700017408],
              [-76.68139600042502, 38.75740099955658],
              [-76.63307000038014, 38.767823999977736],
              [-76.62325300002584, 38.72647100043645],
              [-76.45843400042872, 38.71122199959575],
              [-76.42270500033544, 38.87096599988115],
              [-76.35099100003453, 39.04667299975927],
              [-76.34506800028794, 39.15170400043945],
              [-76.23645800003658, 39.304058999923086],
              [-76.12737200031745, 39.384444999936875],
              [-76.07682699956621, 39.40241799959114],
              [-76.04706600039555, 39.38002000002302],
              [-75.98178900016217, 39.36643600042123],
              [-75.76701399999604, 39.37710599964231],
              [-75.69387100034629, 38.46001100000774],
              [-74.98628199981442, 38.451585999993995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8658840',
        DATE_GRANT: '2014-12-17',
        FILE_NUM: '0006534031',
        CALL_SIGN: 'KNKN634',
        MARKET: 'CMA692',
        BLOCK: 'A',
        DATE_CREAT: '2014-11-07',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-75.19117200008765, 37.996029000038504],
              [-75.30313200014166, 37.838169000299274],
              [-75.36012499966898, 37.810186000383794],
              [-75.40928500040235, 37.82091899981202],
              [-75.46093299985802, 37.77135600027924],
              [-75.54177900040048, 37.60614499969216],
              [-75.5296979999627, 37.55766099955548],
              [-75.5891100004261, 37.47785700030039],
              [-75.60402600029965, 37.42202400030743],
              [-75.64345600019413, 37.37286399957395],
              [-75.64438599991394, 37.34226999976079],
              [-75.71551500021707, 37.275686999555546],
              [-75.72927099965688, 37.21690100008118],
              [-75.76604899956163, 37.15493200041152],
              [-75.8896759998475, 37.054515000267145],
              [-75.9254199997331, 36.94623800008367],
              [-75.98232299960665, 36.93258099981341],
              [-76.08139599982547, 36.94607199962314],
              [-76.16984100006209, 36.98809899966926],
              [-76.20856199963652, 37.06356500032456],
              [-76.20142499966391, 37.15864699995916],
              [-76.22988600003885, 37.23038899975268],
              [-76.34595099963883, 37.24212899975362],
              [-76.3811169998495, 37.25936000026377],
              [-76.39408699991509, 37.313279000125874],
              [-76.43837800004462, 37.31653199995202],
              [-76.40418299964563, 37.33391600032331],
              [-76.47020700015287, 37.368137000122545],
              [-76.45166600038556, 37.38808099983845],
              [-76.41133700040223, 37.369013000050074],
              [-76.41613699962272, 37.4141139997613],
              [-76.44827300039861, 37.419925999785164],
              [-76.4373250000487, 37.506233000352836],
              [-76.46359300001689, 37.5280880000613],
              [-76.6544040003443, 37.60303099998072],
              [-76.66793100001553, 37.520240999722546],
              [-76.64715599974949, 37.48102599985009],
              [-76.68539200034053, 37.45339099979486],
              [-76.73533000007939, 37.45392400009263],
              [-76.8183520002446, 37.550327000390894],
              [-76.85720799974928, 37.52290700035786],
              [-76.87725100043326, 37.52936599964124],
              [-76.85873399997405, 37.579361000209985],
              [-76.88237800034437, 37.576274999991426],
              [-76.87345900003271, 37.55491999995809],
              [-76.89416499981485, 37.54552500017866],
              [-76.92052500042837, 37.569099000018866],
              [-76.93863700019739, 37.562545999998065],
              [-76.94483900021964, 37.537701000001334],
              [-76.97428900033708, 37.541110999872785],
              [-76.95848099979827, 37.55490500016572],
              [-76.9670259999499, 37.58568599960927],
              [-77.01284799963543, 37.56415899973803],
              [-77.01956900020912, 37.58355700035537],
              [-77.08043700036723, 37.59645099961409],
              [-77.09038499956796, 37.618434999875376],
              [-77.11775199985487, 37.62374500013175],
              [-77.12989000022327, 37.63542199992554],
              [-77.10941300020977, 37.65368300027029],
              [-77.14762100040878, 37.67506399970398],
              [-77.18586000023873, 37.6574939997484],
              [-77.18360100038569, 37.685534999640595],
              [-77.23518400044122, 37.685286999895254],
              [-77.24388899987736, 37.699104000349394],
              [-77.23036200020613, 37.71343600027137],
              [-77.24489599955069, 37.73077799960515],
              [-77.24412499996873, 37.71219299960734],
              [-77.26983600033111, 37.7235760002323],
              [-77.2925639998287, 37.71428699994527],
              [-77.2937470004237, 37.7399220004001],
              [-77.32281500001221, 37.733604000424464],
              [-77.30152100009394, 37.75114399989582],
              [-77.33108500007262, 37.75297499979649],
              [-77.32939100019439, 37.788234999845486],
              [-77.3554989999788, 37.796333000068046],
              [-77.37445099981369, 37.776737000212506],
              [-77.40608199978442, 37.781852999616376],
              [-77.39562999982462, 37.803309999856765],
              [-77.4187320003814, 37.809269000364225],
              [-77.44502999993443, 37.89459199962124],
              [-77.49275200000477, 37.88911099957312],
              [-77.52919799988769, 37.920811000027754],
              [-77.5574189999868, 37.923470000340274],
              [-77.54621100023735, 37.928204000114704],
              [-77.56978600012377, 37.954196999991666],
              [-77.61225099968385, 37.949859999639386],
              [-77.64244099975218, 37.99102400035747],
              [-77.37059800019745, 38.24644900002153],
              [-77.33303099988069, 38.2457120002087],
              [-77.33968400001646, 38.30282199973567],
              [-77.31990099963139, 38.345798000377556],
              [-77.25000000019975, 38.33150100027109],
              [-77.17964200037795, 38.34178899986256],
              [-77.13852700012086, 38.367790000108585],
              [-77.09384199980843, 38.367172000387654],
              [-77.04258699959024, 38.400817999750984],
              [-77.01196300019228, 38.3742640000836],
              [-77.02947200003268, 38.31101199970419],
              [-76.96247899980585, 38.256378000144764],
              [-76.96262400019737, 38.217159000087975],
              [-76.877959999854, 38.173736999563005],
              [-76.61148100034785, 38.14847600016742],
              [-76.60146299971763, 38.11397900023081],
              [-76.52337599960265, 38.04842799995231],
              [-76.3266039995749, 38.029781999839486],
              [-76.23222600002981, 38.06042099992925],
              [-76.16019100021447, 38.01155300007099],
              [-76.14465799976682, 37.97912400017259],
              [-76.12596400013842, 38.00700900006541],
              [-76.06003000018433, 37.871799999870234],
              [-76.09609899976891, 37.703065000449385],
              [-76.06812400022233, 37.64143999955644],
              [-76.04899600036498, 37.65587599977761],
              [-76.01206499969993, 37.76657900032063],
              [-75.93032600024463, 37.84693599989663],
              [-75.89096900011924, 37.90925300032569],
              [-75.79113499988023, 37.9120669996924],
              [-75.70498700034972, 37.95457500033609],
              [-75.65602899993831, 37.94531300039466],
              [-75.6259610001, 37.989677000293455],
              [-75.23689399965826, 38.03523300030275],
              [-75.21286999975064, 37.98375199955524],
              [-75.19117200008765, 37.996029000038504],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        ULS_ID: '8204476',
        DATE_GRANT: '2014-05-16',
        FILE_NUM: '0006203547',
        CALL_SIGN: 'KNKN704',
        MARKET: 'CMA689',
        BLOCK: 'A',
        DATE_CREAT: '2025-04-15',
        VERSION: 'Current',
        AsOf: '2025-04-24',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-76.4578020000622, 36.9613950002792],
              [-76.48541299990984, 36.9497759995628],
              [-76.48271200035845, 36.928493000151946],
              [-76.50208299973053, 36.91349400004816],
              [-76.5273130003946, 36.91528699999509],
              [-76.8979800003766, 36.64385200036958],
              [-76.90979000000846, 36.57901799988093],
              [-76.92797100026144, 36.56224099962253],
              [-76.91636700023673, 36.54366299994757],
              [-77.71658499969794, 36.545207000103005],
              [-77.7469790001806, 36.576141000307075],
              [-77.65613599997636, 36.713390000148365],
              [-77.65832500019849, 36.89436700023697],
              [-77.6336289998784, 36.87500000014995],
              [-77.63910699978817, 36.88417100039146],
              [-77.15573100028541, 37.11188500009274],
              [-77.07305900007276, 37.184447999975305],
              [-77.02438400012142, 37.20087800041955],
              [-77.01261899986679, 37.23273500002034],
              [-76.97275499974342, 37.248351999845056],
              [-76.91048399963682, 37.22325900010276],
              [-76.80924999958779, 37.22219799973806],
              [-76.74387400018486, 37.171023999657905],
              [-76.70595599986945, 37.206286999845304],
              [-76.66076699969722, 37.203998999554244],
              [-76.64399699976167, 37.190192999607405],
              [-76.64614099970731, 37.12500800001931],
              [-76.62852500032847, 37.09260899970576],
              [-76.4578020000622, 36.9613950002792],
            ],
          ],
        ],
      },
    },
  ],
}
